import { SocialNetworkIconsProps } from '../@types/SocialNetworkProps';
import * as Icon from '../../Footer/images/index';

type SocialNetworkLinkProps = {
	socialNetworks: SocialNetworkIconsProps;
	showInColor?: boolean;
	blockClass?: string;
};

const SocialNetworkLink = ({ socialNetworks, showInColor = false, blockClass }: SocialNetworkLinkProps) => {
	const iconIndex: keyof typeof Icon = `${socialNetworks.name!}${showInColor ? '' : 'Bw'}`;
	return (
		<a
			href={socialNetworks?.url}
			className={`vtex-store-footer-2-x-socialNetworkLink vtex-store-footer-2-x-socialNetworkLink--${blockClass} vtex-store-footer-2-x-socialNetworkLink--${socialNetworks.name?.toLowerCase()} c-muted-1 w2 h2 mh2 flex items-center`}
			target="_blank"
			rel="noreferrer"
		>
			<img
				className={`vtex-store-footer-2-x-socialNetworkImage vtex-store-footer-2-x-socialNetworkImage--${blockClass}`}
				src={Icon[iconIndex]}
				alt={socialNetworks.name}
			/>
		</a>
	);
};

export default SocialNetworkLink;
